/**
 * Reine Typeahead-Filterfunktion fuer den Kategorie-Modus (Phase 4, CAT-02).
 *
 * KEIN React-/Netzwerk-Import — nur clientseitige Filterung der bereits geladenen
 * Kategorienliste (aus GET /pool/categories), damit sie per Vitest isoliert testbar ist.
 */

export interface CategoryOption {
  categoryId: number;
  label: string;
}

/**
 * Filtert `list` per case-insensitivem Teilstring-Match auf `label`.
 * - Leerer/whitespace-only `query` -> gibt `list` unveraendert zurueck.
 * - Nicht-leerer `query` -> nur Eintraege deren (getrimmtes, lowercased) `label` den
 *   (getrimmten, lowercased) `query` als Teilstring enthaelt.
 * - Kein Treffer -> [].
 * - Reihenfolge der Eingabeliste bleibt erhalten.
 */
export function filterCategories(list: CategoryOption[], query: string): CategoryOption[] {
  const trimmedQuery = query.trim().toLowerCase();
  if (trimmedQuery === '') return list;

  return list.filter(entry => entry.label.trim().toLowerCase().includes(trimmedQuery));
}
